import { gql } from '@apollo/client';

export const GET_EQUIPMENT_BY_ID = gql`
  query GetEquipmentById($id: ID!) {
    equipment: equipmentById(id: $id) {
      year
      make
      model
      modelBase
      stockId
      newUsed
      mileage
      hours
      quantity
      classType
      truckClass
      equipmentId
      retailPrice
      attachments
      discountType
      wholesaleCost
      discountValue
      serialNumberVin
      totalWholesaleCost
      additionalDescription
      inventoryItem {
        inventoryId
        status
      }
    }
  }
`;
